<script lang="ts">
	import { DeviceGroup } from "luxedo-data"
	import { reactivateGroup } from "../../../GroupReactivator"
	import { Toast } from "toaster"

	interface Props {
		device: DeviceGroup
		isDisabled: boolean
		setButtonsDisabled: (doDisable?: boolean) => void
	}

	let { device, isDisabled, setButtonsDisabled }: Props = $props()

	/**
	 * Reactivates the selected group by deactivating active conflicting groups
	 */
	async function onReactivateGroup() {
		if (!(device instanceof DeviceGroup)) return

		reactivateGroup(device)

		Toast.success(`Group ${device.isDeactivated ? "deactivated" : "activated"} successfully!`)
	}
</script>

<div class="action-container">
	<button
		class="outline-button"
		id="rollback-button"
		onclick={onReactivateGroup}
		disabled={isDisabled}>Reactivate Group</button
	>
	<div class="action-info">
		Deactivates other groups that share devices with this group and reactivates it.
	</div>
</div>

<style>
</style>
